import React from 'react';
import {
    TableCell,
    TableFooter,
    TablePagination,
    TableRow,
} from '@mui/material';

type FooterTextLabels = {
    pagination?: {
        rowsPerPage?: string;
        displayRows?: string;
    };
};

const defaultRowsPerPageOptions = [15, 30, 50];

export const createTablePaginationWithFirstLast = (
    rowsPerPageOptions: number[] = defaultRowsPerPageOptions
) => (
    rowCount: number,
    page: number,
    rowsPerPage: number,
    changeRowsPerPage: (rows: number) => void,
    changePage: (newPage: number) => void,
    textLabels: FooterTextLabels
) => {
    const paginationLabels = textLabels.pagination || {};

    return (
        <TableFooter>
            <TableRow>
                <TableCell colSpan={1000}>
                    <TablePagination
                        component="div"
                        count={rowCount}
                        page={page}
                        rowsPerPage={rowsPerPage}
                        rowsPerPageOptions={rowsPerPageOptions}
                        onPageChange={(_event, newPage) => changePage(newPage)}
                        onRowsPerPageChange={(event) => {
                            changeRowsPerPage(Number(event.target.value));
                        }}
                        labelRowsPerPage={paginationLabels.rowsPerPage || 'Linhas por pagina:'}
                        labelDisplayedRows={({ from, to, count }) =>
                            `${from}-${to} ${paginationLabels.displayRows || 'de'} ${count}`
                        }
                        showFirstButton
                        showLastButton
                    />
                </TableCell>
            </TableRow>
        </TableFooter>
    );
};
